import {Component, Input, OnInit, OnChanges, SimpleChanges, EventEmitter, Output} from '@angular/core';
import {allCards} from '../cards-mockup';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnChanges, OnInit {

  @Input() counter: number;
  @Input() level: number;
  @Output() counterClosedCards = new EventEmitter<number>();

  cardsId: number[] = [];
  isCardVisible: boolean[] = [];
  counterOpenCards: number;
  numberOfTotalCards: number;
  cards = allCards;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    // generate a new exercise
    this.generateRandomExercise();
  }

  ngOnInit() {
    // this.generateRandomExercise();
  }

  initValues() {
    this.cardsId = [];
    this.isCardVisible = [];
    this.numberOfTotalCards = 0;
  }

  generateRandomExercise() {
    this.initValues();

    this.numberOfTotalCards = this.getNumberOfCards();

    this.constructListCards();

    const minCardsOpen = this.getMinCardsOpen();
    this.generateMinOpenMinClosed(minCardsOpen, 2);

    this.sendCounterClosedCards();
  }

  sendCounterClosedCards() {
    if ((this.counterOpenCards % 2) === 0) {
      this.counterClosedCards.emit(2);
    } else {
      this.counterClosedCards.emit(1);
    }
  }

  getNumberOfCards() {
    if (this.level === 1) {
      return Math.floor((Math.random() * 2) + 5); // 5 6
    } else if (this.level === 2) {
      return Math.floor((Math.random() * 3) + 8); // 8 9 10
    } else {
      return Math.floor((Math.random() * 4) + 13); // 13 14 15 16
    }
  }

  getMinCardsOpen() {
    if (this.level === 1) {
      return 1;
    } else {
     return Math.floor(this.numberOfTotalCards / 2) + 1;
    }
  }

  constructListCards() {
    for (let i = 0; i < this.numberOfTotalCards; i++) {
      const randomId = Math.floor((Math.random() * 127));
      this.cardsId.push( randomId );
    }

    this.counterOpenCards = 0;
    for (let i = 0; i < this.numberOfTotalCards; i++) {
      const rand = Math.floor((Math.random() * 2));
      if (rand === 0) {
        this.isCardVisible.push(false);
      } else {
        this.isCardVisible.push(true);
        this.counterOpenCards ++;
      }
    }
  }

  generateMinOpenMinClosed(minOpen: number, minClosed: number) {
    // At least minCardsOpen cards are open
    while (this.counterOpenCards < minOpen) {
      const rand = Math.floor((Math.random() * this.numberOfTotalCards));
      if (this.isCardVisible[rand] === false) {
        this.isCardVisible[rand] = true;
        this.counterOpenCards ++;
      }
    }

    // At least minClosed cards are closed
    while (this.numberOfTotalCards - this.counterOpenCards < minClosed) {
      const rand = Math.floor((Math.random() * this.numberOfTotalCards));
      if (this.isCardVisible[rand]) {
        this.isCardVisible[rand] = false;
        this.counterOpenCards --;
      }
    }
  }

  getImageSrc(i: number) {
    if (this.isCardVisible[i]) {
      return this.cards[this.cardsId[i]].imageSrc;
    } else {
      return './assets/images/kartentricks/card_cover.png';
    }
  }

  isCover(i: number) {
    return !this.isCardVisible[i];
  }

  getMaxSize() {
    if (this.level === 1) {
      return '13%';
    } else {
      return '10%';
    }
  }
}
